
























































































































import { DeviceManagementActions } from '@/constants/device-management'

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    deviceManagementAction: {
      type: String,
      required: true,
    },
    allDevices: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isAttemptingDeviceRemoval: false,
      showConfirmRemoveDevicesDialog: false,
    }
  },

  computed: {
    isRemoveDevicesAction() {
      return this.deviceManagementAction === DeviceManagementActions.RemoveDevices
    },
    isReplaceDevicesAction() {
      return this.deviceManagementAction === DeviceManagementActions.ReplaceDevices
    },
    deviceActionText() {
      if (this.isRemoveDevicesAction) {
        return 'remove'
      }
      if (this.isReplaceDevicesAction) {
        return 'replace'
      }
      return 'add'
    },
    availableDevices() {
      return this.allDevices.filter(device => !device.hasSuccessfulRemovalFromGateway)
    },
    numberOfAvailableDevices() {
      return this.availableDevices.length
    },
    selectedDevices() {
      return this.availableDevices.filter(device => device.isSelected)
    },
    selectedDeviceNamesString() {
      return this.selectedDevices.map(device => device.name).join(', ')
    },
    removedDevices() {
      return this.allDevices.filter(device => device.hasSuccessfulRemovalFromGateway)
    },
    numberOfRemovedDevices() {
      return this.removedDevices.length
    },
    numberOfSelectedDevices() {
      return this.selectedDevices.length
    },
    noDevicesSelected() {
      return this.numberOfSelectedDevices <= 0
    },
    allDevicesSelected() {
      return this.numberOfSelectedDevices === this.numberOfAvailableDevices
    },
    someDevicesSelected() {
      return !this.noDevicesSelected && !this.allDevicesSelected
    },
    selectAllIcon() {
      return this.allDevicesSelected
        ? 'mdi-close-box'
        : this.someDevicesSelected
        ? 'mdi-minus-box'
        : 'mdi-checkbox-blank-outline'
    },
  },

  methods: {
    selectAllAction() {
      const updatedDevices = this.allDevices.map(device => ({
        ...device,
        isSelected: device.hasSuccessfulGatewayConnection ? true : this.allDevicesSelected ? false : true,
      }))
      this.setStageValidity(updatedDevices)
      this.$emit('setSelectedDevices', updatedDevices)
    },
    setSelectedDevices(deviceName: string) {
      const updatedDevices = this.allDevices.map(device => ({
        ...device,
        isSelected: device.name === deviceName ? !device.isSelected : device.isSelected,
      }))
      this.setStageValidity(updatedDevices)
      this.$emit('setSelectedDevices', updatedDevices)
    },
    setStageValidity(devices: any[] = []) {
      this.$emit('stageIsValid', {
        stageIndex: this.stageIndex,
        isValid: this.isRemoveDevicesAction
          ? this.numberOfRemovedDevices >= 1
          : devices.filter(device => device.isSelected).length >= 1,
      })
    },
    setDeviceRemoval(device) {
      this.$emit('setDeviceRemoval', {
        ...device,
        hasAttemptedGatewayConnection: true,
        hasSuccessfulRemovalFromGateway: true,
        isSelected: false,
      })
    },
    openConfirmRemoveDevicesDialog() {
      this.showConfirmRemoveDevicesDialog = true
    },
    closeConfirmRemoveDevicesDialog() {
      this.showConfirmRemoveDevicesDialog = false
    },
    async removeDevicesFromGateway() {
      try {
        console.info('this function will remove selected devices from the gateway')
        const devicesToRemove = this.selectedDevices
        this.closeConfirmRemoveDevicesDialog()
        this.isAttemptingDeviceRemoval = true
        devicesToRemove.forEach((device, index) => {
          const timeout = (index + 1) * 2000
          setTimeout(() => {
            this.setDeviceRemoval(device)
            if (index === devicesToRemove.length - 1) {
              this.isAttemptingDeviceRemoval = false
              this.setStageValidity()
            }
          }, timeout)
        })
      } catch (err) {
        console.log(err)
      }
    },
  },
}
